<template>
  <div class="container no-margin">
    <text-input
      :hint="placeholder"
      :scroll-on-focus="scrollOnFocus"
      :label="label"
      :value="value"
      :name="name"
      @input="onInput"
      @click="$emit('click')"
      @onFocus="$emit('onFocus')"
      :required="required"
      pattern="[0-9]*"
      inputmode="numeric"
      :maxlength="maxlength"
      :subhint="subhint"
      :validation-error="error"
      :analyticsName="analyticsName"
      :analyticsTypology="config.analyticsTypology"
      :analyticsSubmodule="analyticsSubmodule"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import TextInput from "@/__tests-ab__/AR2024CNOMV2/components/core/TextInput";
export default {
  name: "NumberInput",
  components: { TextInput },
  props: {
    placeholder: String,
    label: String,
    value: String,
    name: String,
    maxlength: String,
    subhint: String,
    validationError: String,
    scrollOnFocus: {
      type: Boolean,
      default: true
    },
    analyticsName: {
      type: String,
      default: null
    },
    analyticsSubmodule: {
      type: String,
      default: null
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false
    };
  },
  computed: {
    error() {
      if (this.checked) {
        if (this.validationError) {
          return this.validationError;
        } else if (this.isVoid()) {
          return "Tenés que ingresar este dato";
        } else if (!this.isValid()) {
          return "El número no es válido";
        }
      }
      return null;
    }
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    checkValid() {
      this.checked = true;
      return this.isValid();
    },
    isVoid() {
      return this.value == null || this.value.trim() === "";
    },
    isValid() {
      if (this.required) {
        const numberRegex = /^[0-9]*$/;
        return numberRegex.test(this.value.trim());
      }
      return true;
    }
  }
};
</script>
